import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  Image,
  Select,
  Button,
  Show,
  useBreakpointValue,
} from "@chakra-ui/react";
import TaskImg1 from "@/assets/images/creator_img1.png";
import TaskImg2 from "@/assets/images/creator_img2.png";
import creatorAd from "@/assets/images/creator_ad.png";
import NewImg from "@/assets/images/creator_img3.png";
import { RiArrowRightSLine } from "@remixicon/react";
import CreativitySchoolItem from "@/components/creatorcenter/creativityschoolitem";
import { Courses, WorkInfo } from "@/types/creatorcenter";
import SchoolItemImg from "@/assets/images/creator_img4.png";
import WorksDataItem from "@/components/creatorcenter/worksdataitem";
import { useNavigate } from "react-router-dom";

const CreatorCenterHome = () => {
  const navigate = useNavigate();

  const column = useBreakpointValue({
    base: 2, // 屏幕宽度小于40em（640px）时的值
    sm: 2,   // 屏幕宽度在40em-52em（640px-853px）之间时的值
    md: 3,   // 屏幕宽度在52em-64em（853px-1024px）之间时的值
    lg: 4,   // 屏幕宽度在64em-80em（1024px-1280px）之间时的值
    xl: 5,  // 屏幕宽度在80em-100em（1280px-1920px）之间时的值
  })
  const column2 = useBreakpointValue({
    base: 2, // 屏幕宽度小于40em（640px）时的值
    sm: 2,   // 屏幕宽度在40em-52em（640px-853px）之间时的值
    md: 3,   // 屏幕宽度在52em-64em（853px-1024px）之间时的值
    lg: 4,   // 屏幕宽度在64em-80em（1024px-1280px）之间时的值
    xl: 5,  // 屏幕宽度在80em-100em（1280px-1920px）之间时的值
  })
  
  const workInfo: WorkInfo = {
    id: "mw555zq4ujrgtj1189uxuwkika",
    intro: "梦幻空间 彩色 水母",
    image_url: `${NewImg}`,
    like_num: 2341,
    collect_num: 1,
    page_view: 1,
    onekey_nums: 18,
    share_num: 1,
    comment_num: 1000,
    fans_num: 1,
    publish_time: "2024-08-09",
    // 图表配置项
    lineOption: {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
        padding: [5, 10],
      },
      // legend: {
      //   data: ['销量'],
      // },
      xAxis: {
        data: ["04/07", "04/07", "04/07", "04/07", "04/07", "04/07"],
        show: true,
        boundaryGap: false,
        axisLabel: {
          interval: 0, // 强制显示所有标签
          showMaxLabel: true,
          margin: 10,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        axisLabel: {
          // 使用 formatter 函数来格式化标签文本
          formatter: "{value} 人", // 这里的 '{value} 人' 就是标签加上了单位 "人"
          margin: 20, // 设置刻度标签距离轴的距离为20
        },
        axisTick: {
          show: false,
        },
      },
      grid: {
        left: 0,
        right: 30,
        bottom: 0,
        top: 10,
        containLabel: true, // 是否包含坐标轴的标签
      },
      series: [
        {
          name: "观看量",
          type: "line",
          // smooth: true,
          data: [1, 244, 699, 10, 107, 20],
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
        {
          name: "评论数",
          type: "line",
          // smooth: true,
          data: [188, 628, 166, 1000, 107, 450],
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
        {
          name: "点赞量",
          type: "line",
          // smooth: true,
          data: [14, 208, 360, 100, 10, 20],
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
        {
          name: "分享数",
          type: "line",
          // smooth: true,
          data: [1, 2, 377, 109, 614, 21],
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
        {
          name: "涨粉数",
          type: "line",
          // smooth: true,
          data: [1, 20, 386, 190, 10, 20],
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
        {
          name: "被同款数",
          type: "line",
          // smooth: true,
          data: [1, 312, 514, 10, 150, 12],
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
      ],
    },
  };

  const CoursesList: Courses[] = [
    {
      id: "1",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
    {
      id: "2",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
    {
      id: "3",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
    {
      id: "4",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
    {
      id: "5",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
  ];

  return (
    <Box h="100%" pl="20px" pr="20px" overflow={"auto"}>
      <Flex gap={"20px"}>
        <Box
          // gridColumn="span 2"
          flex={1}
          borderWidth="1px"
          borderColor={"#DCE0EB"}
          p="20px"
        >
          <Box mb="20px" fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            新的任务
          </Box>
          <Flex gap={"20px"}>
            <Box
              flex={1}
              minH="90px"
              bg="linear-gradient(90deg, #FEF8EF 0%, #FCF2E4 100%)"
            >
              <Flex h="100%" p="12px" alignItems={"center"} boxSizing="border-box" gap={"10px"}>
                <Image
                  w="54px"
                  h="100%"
                  objectFit="contain"
                  src={TaskImg1}
                ></Image>
                <Box flex={1} w="0">
                  <Box
                    color={"#27314D"}
                    fontSize={"16px"}
                    fontWeight="500"
                    mb={"5px"}
                  >
                    AI创作
                  </Box>
                  <Box
                    color={"#8E94A9"}
                    fontSize={"12px"}
                    // whiteSpace="nowrap"
                    // overflow={"hidden"}
                    // textOverflow="ellipsis"
                  >
                    在AI创作可以进行AI绘画创作，选择不同的模型效果生成你的AI设计作品
                  </Box>
                </Box>
              </Flex>
            </Box>
            <Box
              flex={1}
              minH="90px"
              bg="linear-gradient(90deg, #F2F8FC 0%, #CFDCEA 100%)"
            >
              <Flex h="100%" p="12px" alignItems={"center"} boxSizing="border-box" gap={"10px"}>
                <Image
                  w="54px"
                  h="100%"
                  objectFit="contain"
                  src={TaskImg2}
                ></Image>
                <Box flex={1} w="0">
                  <Box
                    color={"#27314D"}
                    fontSize={"16px"}
                    fontWeight="500"
                    mb={"5px"}
                  >
                    模型训练
                  </Box>
                  <Box
                    color={"#8E94A9"}
                    fontSize={"12px"}
                    // whiteSpace="nowrap"
                    // overflow={"hidden"}
                    // textOverflow="ellipsis"
                  >
                    支持自有模型训练，快去训练属于你的模型吧～
                  </Box>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Box>
        <Show breakpoint='(min-width: 1270px)'>
          <Flex
            borderWidth="1px"
            borderColor={"#DCE0EB"}
            p="20px"
            flexDir={"column"}
            maxW="33%"
          >
            <Box
              mb="20px"
              fontSize={"18px"}
              fontWeight="bold"
              color={"#27314D"}
            >
              创作者招募计划
            </Box>
            <Box bgColor={"#496AE1"} flex="1">
              <Image w="100%" h="92px" src={creatorAd} />
            </Box>
          </Flex>
        </Show>
      </Flex>
      <Box borderWidth="1px" borderColor={"#DCE0EB"} p="20px" mt="20px">
        <Flex mb="20px" justifyContent={"space-between"}>
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            数据总览
          </Box>
          <Flex alignItems={"center"}>
            <Text fontSize={"12px"} color={"#8E94A9"}>
              筛选条件:{" "}
            </Text>
            <Select
              color={"#27314D"}
              fontSize={"12px"}
              w="80px"
              border={"none"}
              size="xs"
              placeholder="请选择"
            >
              <option>近7日</option>
            </Select>
          </Flex>
        </Flex>
        <SimpleGrid columns={column} spacing={"20px"}>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              新增粉丝数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              1
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              主页访客
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              0
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              观看数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              451
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              被同款数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              10
            </Box>
          </Box>
          <Box p="10px 20px" bgColor={"rgba(238, 241, 247, 0.5)"}>
            <Box color={"#8E94A9"} fontSize="14px">
              互动数
            </Box>
            <Box color={"#333C58"} fontSize="28px" fontFamily="Allerta">
              1218
            </Box>
          </Box>
        </SimpleGrid>
        <Flex mt={"40px"} mb="20px" justifyContent={"space-between"}>
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            最新发布创作数据
          </Box>
          <Button
            color="#27314D"
            fontSize={"12px"}
            fontWeight="normal"
            variant="link"
            onClick={()=> navigate("/creatorcenter/datacenter")}
          >
            查看全部 <RiArrowRightSLine size={"12px"} />
          </Button>
        </Flex>
        <WorksDataItem workInfo={workInfo} />
      </Box>
      <Box borderWidth="1px" borderColor={"#DCE0EB"} p="20px" mt="20px">
        <Box mb="20px" fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
          创作学院
        </Box>
        <SimpleGrid columns={column2} spacing={"20px"}>
          {CoursesList.map((item) => {
            return (
              <Box key={item.id}>
                <CreativitySchoolItem courses={item} />
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default CreatorCenterHome;
